// Gallery
if (document.querySelectorAll('.js-imageGallery-cb').length) {
  import(
    /* webpackChunkName: "photoswipe" */ '../templates/_organisms/imageGallery/_script-cb.js'
  )
    .then(photoswipe => photoswipe.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Slider
if (document.querySelectorAll('.js-slider-basic').length) {
  import(
    /* webpackChunkName: "slider" */ '../templates/_organisms/slider/_script-basic.js'
  )
    .then(slider => slider.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Slider
if (document.querySelectorAll('.js-slider-seminare').length) {
  import(
    /* webpackChunkName: "sliderSeminare" */ '../templates/_organisms/slider/_script-seminare.js'
  )
    .then(sliderSeminare => sliderSeminare.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Grid Overlay
if (document.querySelectorAll('.m-gridOverlay-basic').length) {
  import(
    /* webpackChunkName: "gridOverlay" */ '../templates/_molecules/gridOverlay/_script-basic.js'
  )
    .then(gridOverlay => gridOverlay.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}


// Form Freeform
if (document.querySelectorAll('.o-form-seminar').length) {
  import(
    /* webpackChunkName: "formFreeform" */ '../templates/_organisms/form/_script-freeform.js'
  )
    .then(formFreeform => formFreeform.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Form Seminar
if (document.querySelectorAll('.o-form-seminar').length) {
  import(
    /* webpackChunkName: "formSeminar" */ '../templates/_organisms/form/_script-seminar.js'
  )
    .then(formSeminar => formSeminar.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Form Lehrgang
if (document.querySelectorAll('.o-form-lehrgang').length) {
  import(
    /* webpackChunkName: "formLehrgang" */ '../templates/_organisms/form/_script-lehrgang.js'
  )
    .then(formLehrgang => formLehrgang.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// Modules Accordion
if (document.querySelectorAll('.m-eventsModuleAccordion-basic').length) {
  import(
    /* webpackChunkName: "eventsModuleAccordion" */ '../templates/_molecules/eventsModuleAccordion/_script-basic.js'
  )
    .then(eventsModuleAccordion => eventsModuleAccordion.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}

// App Header
if (document.querySelectorAll('.o-appHeader-basic').length) {
  import(
    /* webpackChunkName: "appHeader" */ '../templates/_organisms/appHeader/_script-basic.js'
    )
    .then(appHeader => appHeader.default.init())
    .catch(e => console.error(`${e.name} : ${e.message}`));
}
